// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"49ccb12c","223":"30b32a7d","301":"189b883f","433":"a679f6bf","573":"2d1ee780","830":"f2f777e1","968":"d981f032"}[chunkId] + ".chunk.js";
};